import React, { Component } from 'react';
import { connect } from 'react-redux';

import { Firebase, unscopeFullstoryCapture } from './../../util';

import { Redirect } from 'react-router-dom';

import qs from 'qs';

class Logout extends Component {

  componentWillMount(){

    let self = this;

    unscopeFullstoryCapture();

    Firebase.auth().signOut().then(function() {
      // Sign-out successful.
      console.log('logout success');

      //auth will be udpated and user will be redirected after auth cleared upon
      //page load
      //window.location.reload();

      const params = qs.parse(self.props.location.search, { ignoreQueryPrefix: true });

      if(params.continueUrl){
        document.location.href = params.continueUrl;
      }
      else{
        window.location.reload();
      }


    }, function(error) {
      // An error happened.
      console.log('logout error');
    });
  }

  render() {
    const { authenticated } = this.props;

    if (!authenticated) {
      return <Redirect to={'/login'} />
    }

    return null;
  }
}

function mapStateToProps(state){
  return {
    authenticated: (state.user && state.user.uid) ? true : false
  }
}

export default connect(mapStateToProps)(Logout);



// WEBPACK FOOTER //
// ./src/components/logout/index.js